import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { LoadingService } from '../../shared/services/loading.service';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';
import { PlaylistService } from '../../shared/services/playlist.service';
import { Playlist } from '../../shared/classes/playlist';
import { Video } from '../../shared/classes/video';
import { Settings } from '../../shared/settings';
import { faTheaterMasks } from '@fortawesome/free-solid-svg-icons';

declare const initFWDUVPlayer: any;
declare const $: any;

@Component({
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.css']
})

export class PlayerComponent implements OnInit, OnDestroy, AfterViewInit {
  public screenInPopUp = 'SIGN_IN';
  public messageToScreen = '';
  public loading = true;
  public error = '';
  public playlist: Playlist;
  public displayType = 'fullscreen';
  public maxWidth = 980;
  public maxHeight = 552;
  private playlistId = '';
  private queryParamsSubscription;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private playlistService: PlaylistService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const that = this;
    that.loadingService.Open();
    that.loading = true;

    that.queryParamsSubscription = that.route.queryParams.subscribe(params => {
      that.setDisplayDataFromJSON(that, params);
      this.loadData();
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  setDisplayDataFromJSON(that, data): void {
    if (data && data.playlist) {
      that.playlistId = data.playlist;
      if (data.displayType) {
        that.displayType = data.displayType;
        if (that.displayType === 'responsive') {
          if (data.maxWidth && data.maxHeight) {
            that.maxWidth = data.maxWidth;
            that.maxHeight = data.maxHeight;
          }
        }
      }
    }
  }

  loadData(): void {
    const that = this;
    const hasPlaylistData = that.playlistId && that.playlistId.length > 0;

    if (!hasPlaylistData) {
      // tslint:disable-next-line:max-line-length
      that.loadDisplayDataFromLocalStorage();

      // Se ejecuta únicamente si en la función loadDisplayDataFromLocalStorage no se pudo redirigir con datos
      setTimeout(() => {
        that.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido cargar la playlist que desea visualizar.</p>
          `;
        that.loadingService.Close();
        that.loading = false;
      }, 100);
    } else {
      that.saveDisplayDataInLocalStorage();
      that.savePlaylistIdInDOM();

      setTimeout(() => {
        if (hasPlaylistData) {
          forkJoin([
            that.playlistService.getPlaylist(that.playlistId)
          ]).subscribe(([getPlaylistResponse]) => {
            if (getPlaylistResponse) {
              if (!getPlaylistResponse.HasError) {
                if (getPlaylistResponse.PlaylistData) {
                  that.playlist = Playlist.parse(getPlaylistResponse.PlaylistData);
                  if (that.playlist && (!that.playlist.PlaylistVideos || that.playlist.PlaylistVideos.length === 0)) {
                    that.addEmptyPlaylistVideoURL();
                  }
                  that.initPlayer();
                  $('#myModal').on('hidden.bs.modal', (event) => {
                    if (that.screenInPopUp === 'PLAN_REQUIRED') {
                      window.location.reload();
                    }
                  });
                } else {
                  that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
                  that.loadingService.Close();
                  that.loading = false;
                }
              } else {
                if (getPlaylistResponse.ErrorMessage){
                  that.error = `<p><b>¡Error!</b></p><p>${getPlaylistResponse.ErrorMessage}</p>`;
                } else {
                  that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
                }
                that.loadingService.Close();
                that.loading = false;
              }
            } else {
              that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
              that.loadingService.Close();
              that.loading = false;
            }
          },
          (error) => {
            Utilities.logError('Error al cargar los datos para player.component');
            Utilities.logError(error);
            that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
            that.loadingService.Close();
            that.loading = false;
          });
        } else {
          that.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido cargar la playlist que desea visualizar.</p>
          `;
          that.loadingService.Close();
          that.loading = false;
        }
      }, 300);
    }
  }

  private loadDisplayDataFromLocalStorage(): void {
    const that = this;
    const localStorageDisplayData = localStorage.getItem('APPTenfieldPlayerDisplayData');
    if (localStorageDisplayData) {
      localStorage.removeItem('APPTenfieldPlayerDisplayData');
      const jsonLocalStorageDisplayData = JSON.parse(localStorageDisplayData);
      if (jsonLocalStorageDisplayData.playlist) {
        let redirectURL = Settings.playerURL + `?playlist=${jsonLocalStorageDisplayData.playlist}`;
        if (jsonLocalStorageDisplayData.displayType) {
          redirectURL += `&displayType=${jsonLocalStorageDisplayData.displayType}`;
          if (jsonLocalStorageDisplayData.displayType === 'responsive') {
            if (jsonLocalStorageDisplayData.maxWidth && jsonLocalStorageDisplayData.maxHeight) {
              redirectURL += `&maxWidth=${jsonLocalStorageDisplayData.maxWidth}`;
              redirectURL += `&maxHeight=${jsonLocalStorageDisplayData.maxHeight}`;
            }
          }
        }
        window.location.href =  redirectURL;
      }
    }
  }

  public addEmptyPlaylistVideoURL(): void {
    const that = this;
    that.playlist.PlaylistVideos.push(Video.parse({
      VideoYoutubeUrl: Settings.emptyPlaylistVideoURL,
      VideoCanBePlayed: true,
      VideoTitle: 'Tenfield'
    }));
  }

  public initPlayer(): void {
    const that = this;
    const playlistsId = 'playlists' + that.playlist.PlaylistId;
    setTimeout(() => {
      initFWDUVPlayer({
        instanceName: 'player',
        parentId: 'playerDiv',
        playlistsId,
        displayType: that.displayType,
        maxWidth: that.maxWidth,
        maxHeight: that.maxHeight,
        playIfLoggedIn: 'no',
        playIfLoggedInMessage: 'Para ver el contenido debe iniciar sesión. <a href="https://www.bigcheese.uy" target="_blank">Inicie sesión aquí.</a>'
      });

      that.loadingService.Close();
      that.loading = false;

      // @ts-ignore
      if (window.player) {
        // @ts-ignore
        window.player.addListener(FWDUVPlayer.PLAY, (e) => {
          that.playHandler(e, that);
        });
        // @ts-ignore
        window.player.addListener(FWDUVPlayer.GO_FULLSCREEN, that.fullScreenHandler);
        // @ts-ignore
        window.player.addListener(FWDUVPlayer.GO_NORMALSCREEN, that.normalScreenHandler);
      }

      /*if (that.playlist && that.playlist.PlaylistVideos[0] && !that.playlist.PlaylistVideos[0].VideoCanBePlayed) {
        // Si el primer video de la playlist requiere permisos, se le da play para que aparezca el login
        setTimeout(() => {
          // @ts-ignore
          if (window.player) {
            // @ts-ignore
            // window.player.play();
            that.simulateNotAuthorizedPlay();
          }
        }, 1000);
      }*/
    }, 500);
  }

  public generateVideoURL(video: Video): string {
    let videoURL = Settings.notAuthorizedVideoURL;
    if (video && video.VideoCanBePlayed) {
      const localStorageToken = localStorage.getItem('APPTenfieldPlayerAccessToken');
      const token = localStorageToken && localStorageToken.trim().length > 0 ? localStorageToken.trim() : '';

      if (video.VideoUrl) {
        videoURL = video.VideoUrl;
      } else if (video.VideoYoutubeUrl) {
        videoURL = video.VideoYoutubeUrl;
      }
      if  (video.VideoUrl !== video.VideoYoutubeUrl) {
        if (video.VideoCNDUrl) {
          videoURL = video.VideoCNDUrl;
        }

        videoURL = videoURL.replace('<Token>', token);
      }
    }
    return  videoURL;
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }

  private playHandler(e, context): void {
    const that = context;
    // tslint:disable-next-line:variable-name max-line-length
    const _userIsLoggedIn = localStorage.getItem('APPTenfieldPlayerAccessToken') && localStorage.getItem('APPTenfieldPlayerAccessToken').length > 0;
    if (e && e.target && e.target.curSource) {
      if (e.target.curSource === Settings.notAuthorizedVideoURL && !_userIsLoggedIn) {
        that.screenInPopUp = 'SIGN_IN';
        // @ts-ignore
        window.player.stop();
        $('#myModal').modal('show');
        // ToDo: Resolver el tema de que no se ve el popup cuando se está en fullscreen.
      } else if (e.target.curSource === Settings.notAuthorizedVideoURL && _userIsLoggedIn) {
        // tslint:disable-next-line:max-line-length
        that.screenInPopUp = 'PLAN_REQUIRED';
        // @ts-ignore
        window.player.stop();
        $('#myModal').modal('show');
        // ToDo: Resolver el tema de que no se ve el popup cuando se está en fullscreen.
      }
    }
  }

  private fullScreenHandler(e): void {
    const existingPlaylistIdInDOM = document.getElementById('playlistIdInDOM');
    const playlistIdInDOM = existingPlaylistIdInDOM.getAttribute('playlistId');
    const testData = { eventType: 'fullScreen', playlistId: playlistIdInDOM };

    /*const videoDiv = document.getElementById('playerDiv');
    videoDiv.style.height = '100%';
    videoDiv.style.position = 'fixed';
    videoDiv.style.top = '0';
    videoDiv.style.right = '0';
    videoDiv.style.bottom = '0';
    videoDiv.style.left = '0';*/
    window.parent.postMessage(testData, '*');
  }

  private normalScreenHandler(e): void {
    const existingPlaylistIdInDOM = document.getElementById('playlistIdInDOM');
    const playlistIdInDOM = existingPlaylistIdInDOM.getAttribute('playlistId');
    const testData = { eventType: 'normalScreen', playlistId: playlistIdInDOM };

    /*const videoDiv = document.getElementById('playerDiv');
    videoDiv.style.position = 'relative';*/
    // videoDiv.style.height = '600px';
    // videoDiv.style.height = '464px';

    window.parent.postMessage(testData, '*');
  }

  public changeScreen(event): void {
    if (event.screen) {
      this.screenInPopUp = event.screen;
      this.messageToScreen = event.message || '';
    }
  }

  public logout(): void {
    this.authenticationService.logout(true);
  }

  public userIsLoggedIn(): boolean {
    return this.authenticationService.userIsLoggedIn();
  }

  private savePlaylistIdInDOM(): void {
    const that = this;
    // Me aseguro antes de borrar el elemento en caso de que existiera.
    that.removePlaylistIdFromDOM();
    const playlistIdInDOM = document.createElement('div');
    playlistIdInDOM.id = 'playlistIdInDOM';
    playlistIdInDOM.setAttribute('playlistId', 'playlistId_' + that.playlistId);
    playlistIdInDOM.style.display = 'none';
    // Agrego el elemento al DOM
    const body = document.getElementsByTagName('body')[0];
    // @ts-ignore
    body.appendChild(playlistIdInDOM);
  }

  private saveDisplayDataInLocalStorage(): void {
    const that = this;
    const displayData = {
      playlist: that.playlistId,
      displayType : that.displayType,
      maxHeight: that.maxHeight,
      maxWidth: that.maxWidth
    };
    localStorage.setItem('APPTenfieldPlayerDisplayData', JSON.stringify(displayData));
  }

  private removePlaylistIdFromDOM(): void {
    const existingPlaylistIdInDOM = document.getElementById('playlistIdInDOM');
    if (existingPlaylistIdInDOM) {
      existingPlaylistIdInDOM.parentNode.removeChild(existingPlaylistIdInDOM);
    }
  }

  private simulateNotAuthorizedPlay(): void {
    this.playHandler({target: {curSource: Settings.notAuthorizedVideoURL}}, this);
  }
}
